// import BannerList from './BannerList';
// import BannerCreate from './BannerCreate';
// import BannerEdit from './BannerEdit';
// import LessonIcon from '@material-ui/icons/Class';
import ReportsList from './ReportList';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const reportsReource = {
    list: ReportsList,
    // create: BannerCreate,
    // edit: BannerEdit,
    icon: () => <Icon><Box component="img" src='icons/user-report.svg' /></Icon>,
};

export default reportsReource;